import {
  AlertOutlined,
  AppstoreOutlined,
  BookOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  CloudOutlined,
  CompassOutlined,
  ContainerOutlined,
  DashboardOutlined,
  DockerOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  FlagOutlined,
  FundProjectionScreenOutlined,
  InboxOutlined,
  NotificationOutlined,
  SettingOutlined,
  TeamOutlined,
  ToolOutlined,
  UserOutlined,
} from "@ant-design/icons";

// Backend icon identifiers are the only keys used by sidebar items. Add a new
// identifier here when the navigation API introduces a new icon value.
export const IconRegistry = {
  dashboard: DashboardOutlined,
  ship: DockerOutlined,
  fleet: TeamOutlined,
  users: TeamOutlined,
  user: UserOutlined,
  "vessel-operations": CompassOutlined,
  voyage: EnvironmentOutlined,
  maintenance: ToolOutlined,
  pms: ToolOutlined,
  clock: ClockCircleOutlined,
  calendar: CalendarOutlined,
  logbook: BookOutlined,
  "engine-logbook": SettingOutlined,
  "deck-logbook": BookOutlined,
  "sounding-logbook": FundProjectionScreenOutlined,
  "oil-record-book": FileTextOutlined,
  "garbage-record-book": InboxOutlined,
  "ballast-record-book": ContainerOutlined,
  "bunker-record-book": ContainerOutlined,
  "cargo-record-book": FileTextOutlined,
  "sulphur-record-book": CloudOutlined,
  environment: EnvironmentOutlined,
  compliance: FlagOutlined,
  consumption: FundProjectionScreenOutlined,
  utilities: CalendarOutlined,
  issues: AlertOutlined,
  warning: AlertOutlined,
  notifications: NotificationOutlined,
  settings: SettingOutlined,
};

export const getNavigationIcon = (iconName) =>
  IconRegistry[iconName] || AppstoreOutlined;
